import * as analytics from '../util/analytics';

const ENABLE_LEGEND = 'ENABLE_LEGEND';
const UPDATE_LEGEND_LAYOUT = 'UPDATE_LEGEND_LAYOUT';
const HIDE_COLOR_CHIPS = 'HIDE_COLOR_CHIPS';
const ORDER_LEGEND_ITEMS = 'ORDER_LEGEND_ITEMS';
const MUST_RENDER_FALSE = 'MUST_RENDER_FALSE';

function updateLegendLayout(payload) {
  analytics.track('event', 'Text', 'updateLegendLayout', payload);
  return { type: UPDATE_LEGEND_LAYOUT, payload };
}

function mustRenderFalse(payload) {
  return { type: MUST_RENDER_FALSE, payload };
}

function enableLegend(payload) {
  return { type: ENABLE_LEGEND, payload };
}

function hideColorChips(payload) {
  analytics.track('event', 'Text', 'hideColorChips', payload);
  return { type: HIDE_COLOR_CHIPS, payload };
}

function orderLegendItems(payload) {
  return { type: ORDER_LEGEND_ITEMS, payload };
}

export {
  ENABLE_LEGEND,
  UPDATE_LEGEND_LAYOUT,
  HIDE_COLOR_CHIPS,
  ORDER_LEGEND_ITEMS,
  MUST_RENDER_FALSE,
  updateLegendLayout,
  mustRenderFalse,
  enableLegend,
  hideColorChips,
  orderLegendItems,
};
